import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import actionChangeLang from '../actions/i18n';

const LANG_OPTIONS = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
];

function AuthLangSwitch({ locale, changeLang }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const currentLang =
    LANG_OPTIONS.find(option => option.code === locale) || LANG_OPTIONS[0];

  const toggleMenu = event => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(prev => !prev);
  };

  const selectLang = code => event => {
    event.preventDefault();
    event.stopPropagation();
    changeLang(code);
    setOpen(false);
  };

  return (
    <div className="rts-auth__lang" ref={ref}>
      <button
        type="button"
        className="rts-auth__lang-toggle"
        onClick={toggleMenu}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        Язык: {currentLang.label}
      </button>

      {open && (
        <ul className="rts-auth__lang-menu" role="listbox">
          {LANG_OPTIONS.map(option => (
            <li key={option.code} role="option" aria-selected={option.code === locale}>
              <button
                type="button"
                className={`rts-auth__lang-item${
                  option.code === locale ? ' rts-auth__lang-item--active' : ''
                }`}
                onClick={selectLang(option.code)}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

AuthLangSwitch.propTypes = {
  locale: PropTypes.string.isRequired,
  changeLang: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

const mapDispatchToProps = dispatch => ({
  changeLang: lang => dispatch(actionChangeLang(lang)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthLangSwitch);
